import { useLocation } from 'react-router-dom';
import { parse } from 'qs';

// todo: Fix ts any in another task: https://linear.app/flair/issue/DX-32/fix-typescript-for-qs-dependency
// todo: remove and use new URLSearchParams
export const useQueryParams = (): any => {
  const location = useLocation();
  return parse(location.search, { ignoreQueryPrefix: true });
};
